import React, { useState, useContext, useEffect } from "react";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import axios from "axios";
import moment from "moment";
import DataTable from "react-data-table-component";
import useEntitesTable from "./useEntitesTable.js";
import CustomDeleteButton from "../CustomDeleteButton/CustomDeleteButton.js";
import { makeStyles } from "@mui/styles";
import LinearProgress from "@mui/material/LinearProgress";
import styled from "styled-components";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import Chip from "@mui/material/Chip";
import UserService from "../../services/UserService";
import { getDataFileLog, reloadDataFile, downloadFile } from "services/ConfigServices";
import Tooltip from "@mui/material/Tooltip";
import Dialog from "@mui/material/Dialog";
import { withStyles } from "@mui/styles";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import CustomDialogTitle from "components/Dialog/CustomDialogTitle.js";
import ViewLogsDialog from "./ViewLogsDialog";
import RefreshIcon from '@mui/icons-material/Refresh';

//import "react-table/react-table.css";

// @mui/icons-material
import VisibilityIcon from "@mui/icons-material/Visibility";

import Button from "components/CustomButtons/Button.js";

const useStyles = makeStyles(styles);

const ElementDataDownload = styled.div`
  margin-left: 4px;
  font-weight: 400;
  font-size: 12px;
  font-family: "Source Sans Pro",sans-serif;
  cursor: pointer;
  text-decoration: underline;
`;
const NoData = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
  opacity: 1;
`;
const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);



const RTImportData = () => {
  const appContext = useContext(AdvancedSearchContext);
  const { setPage } = appContext;
  const { gridState, refetch } = useEntitesTable();
  const [logfilename, setLogfilename] = useState("");
  const [openLogs, setOpenLogs] = useState(false);
  const [datafile, setDatafile] = useState(null);

  const classes = useStyles();

  useEffect(() => {
    setPage('imports');
  }, []);

  const { data } = gridState;

  // if (error) {
  //   return (
  //     <p>
  //       <span role="img" aria-label="Problem">
  //         🔧
  //       </span>{" "}
  //       Oups il semble y avoir un problème...{" "}
  //       <button onClick={refetch}>Réesayer</button>
  //     </p>
  //   );
  // }

  const columns = [
    {
      id: 1,
      name: "Date",
      selector: row => row.importDate,
      sortable: true,
      width: "10rem",
      cell: (row) => moment(Number(row.importDate)).format("DD/MM/YYYY HH:mm"),
    },
    {
      id: 2,
      name: "Nom",
      selector: row => row.fileName,
      sortable: true,
      cell: (row) => <ElementDataDownload
        onClick={downloadGED(row.fileId, row.fileName)}> {row.fileName}
      </ElementDataDownload>,
    },
    {
      id: 3,
      name: "Type d'import",
      selector: row => row.importType,
      sortable: true,
    },
    {
      id: 4,
      name: "Utilisateur",
      selector: row => row.importUser,
      sortable: true,
      cell: (row) => row.importUser || ""
    },
    {
      id: 5,
      name: "Groupe",
      selector: row => row.importGroupName,
      sortable: true,
      width: "7rem",
      cell: (row) => row.importGroupName,
    },
    {
      id: 6,
      name: "Status",
      selector: row => row.importStatus,
      sortable: true,
      width: "14rem",
      cell: (row) =>
        row.importStatus == 0 ? (
          <Chip
            label="En cours de traitement"
            style={{
              color: "#FFFFFF",
              borderRadius: "8px",
              backgroundColor: "rgba(62, 143, 198, 1)",
            }}
          />
        ) : row.importStatus == 1 ? (
          <Chip
            label="Non traité"
            style={{
              color: "#FFFFFF",
              borderRadius: "8px",
              backgroundColor: "rgba(255, 67, 45, 1)",
            }}
          />
        ) : row.importStatus == 2 ? (
          <Chip
            label="Traité avec des erreurs"
            style={{
              color: "#FFFFFF",
              borderRadius: "8px",
              backgroundColor: "rgba(255, 67, 45, 1)",
            }}
          />
        ) : row.importStatus == 3 ? (
          <Chip
            label="Traité avec des avertissements"
            style={{
              color: "#FFFFFF",
              borderRadius: "8px",
              backgroundColor: "rgba(255, 118, 58, 1)",
            }}
          />
        ) : row.importStatus == 4 ? (
          <Chip
            label="Traité"
            style={{
              color: "#FFFFFF",
              borderRadius: "8px",
              backgroundColor: "rgba(145, 194, 64, 1)",
            }}
          />
        ) : (
          <Chip
            label="Non traité"
            style={{
              color: "#FFFFFF",
              borderRadius: "8px",
              backgroundColor: "rgba(227, 163, 34, 0.2)",
              fontWeight: "bold",
            }}
          />
        ),
    },
    {
      id: 7,
      name: "Logs",
      selector: row => row.fileId,
      sortable: false,
      width: "4rem",
      cell: (row) =>
        <>
          {row.importStatus != 0 ?
            <div className="actions-right">
              <Tooltip title="Voir les logs">
                <Button
                  onClick={viewLogs(row)}
                  color={"info"}
                  className={classes.actionButton}
                >
                  <VisibilityIcon fontSize="large" />
                </Button>
              </Tooltip>
            </div> : <></>}
        </>
    },
    {
      id: 8,
      name: "Reload",
      selector: row => row.fileId,
      sortable: false,
      width: "4rem",
      cell: (row) =>
        <>
          {row.importStatus != 0 ?
            <div className="actions-right">
              <Tooltip title="Relancer">
                <Button
                  onClick={reloadFile(row)}
                  color={"warning"}
                  className={classes.actionButton}
                >
                  <RefreshIcon fontSize="large" />
                </Button>
              </Tooltip>
            </div> : <></>}
        </>
    },
  ];

  const downloadGED = (fileId, fileName) => async () => {
    axios
      .get(
        downloadFile(fileId, 'import'),
        {
          responseType: "blob",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName); //or any other extension
        document.body.appendChild(link);
        link.click();
      });
  };
  const reloadFile = (row) => async () => {
    axios
      .put(
        reloadDataFile(row.fileId),
        {},
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        refetch();
      });
  };

  const viewLogs = (row) => async () => {
    handleViewLogsOpen();
    axios
      .get(
        getDataFileLog(row.fileId),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          console.log(res);
          row.logs = res.data;
          setDatafile(row);
        }
      });
  };

  const handleViewLogsOpen = () => {
    setOpenLogs(true);
  };
  const handleViewLogsClose = () => {
    setOpenLogs(false);
  };


  return (
    <>
      <div style={{ paddingTop: 10 }}>
        <DataTable
          paginationRowsPerPageOptions={[10,20,30,50,100]}
          defaultSortFieldId={1}
          defaultSortAsc={false}
          noDataComponent={<NoData>Aucun document à afficher</NoData>}
          noHeader={true}
          columns={columns}
          persistTableHead
          pagination
          paginationPerPage={20}
          subHeader
          paginationComponentOptions={{
            noRowsPerPage: false,
            rowsPerPageText: "Lignes par page",
            rangeSeparatorText: "sur",
            selectAllRowsItem: false,
            selectAllRowsItemText: "Selectionner toutes les lignes",
          }}
          progressPending={gridState.loading}
          progressComponent={<LinearProgress />}
          {...gridState}
        ></DataTable>
      </div>
      <Dialog
        onClose={handleViewLogsClose}
        aria-labelledby="edituser-dialog-title"
        fullWidth="true"
        maxWidth="md"
        open={openLogs}
      >
        <CustomDialogTitle id="customized-dialog-title" onClose={handleViewLogsClose}>
          Logs d'import
        </CustomDialogTitle>
        <DialogContent dividers>
          <ViewLogsDialog
            datafile={datafile}
            closeModal={handleViewLogsClose}
          />
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
    </>
  );
};

export default RTImportData;
